import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import MobileNavigation from '../components/MobileNavigation';

const MobilePeople = () => {
  const { people, currentUser } = useApp();
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  if (!currentUser?.sessionId) {
    window.location.href = '/login';
    return null;
  }

  const filteredPeople = people.filter(person => {
    const fullName = `${person.firstName || person.first_name || ''} ${person.lastName || person.last_name || ''}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active': return '#28a745';
      case 'inactive': return '#6c757d';
      case 'suspended': return '#dc3545';
      case 'verified': return '#007bff';
      default: return '#ffc107';
    }
  };

  return (
    <div className="mobile-screen" style={{ paddingTop: '72px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <MobileNavigation />
      
      {/* Header */}
      <div className="mobile-section-header" style={{
        padding: '1rem', 
        backgroundColor: 'white', 
        borderBottom: '1px solid #dee2e6',
        position: 'sticky',
        top: '72px',
        zIndex: 100
      }}>
        <h2 style={{ margin: '0 0 1rem 0', fontSize: '20px', fontWeight: 'bold', color: '#333' }}>
          People ({filteredPeople.length})
        </h2>
        <input
          type="text"
          placeholder="Search people..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            fontSize: '16px'
          }}
        />
      </div>

      {/* People List */}
      <div style={{ padding: '1rem' }}>
        {filteredPeople.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem 1rem',
            color: '#666',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '1rem' }}>👥</div>
            <div style={{ fontSize: '18px', marginBottom: '0.5rem' }}>No people found</div>
          </div>
        ) : (
          filteredPeople.map((person, index) => (
            <div
              key={person.id}
              onClick={() => setSelectedPerson(selectedPerson?.id === person.id ? null : person)}
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid #dee2e6',
                cursor: 'pointer'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                  {person.profileImageUrl ? (
                    <img src={person.profileImageUrl} alt={person.firstName || person.username || 'User'} style={{ width: '52px', height: '52px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                  ) : null}
                  <div>
                  <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: 600, marginBottom: '0.25rem' }}>
                    #{index + 1}
                  </div>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginBottom: '0.25rem' }}>
                    {person.firstName || person.first_name || ''} {person.lastName || person.last_name || ''}
                  </div>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    {person.email || ''}
                  </div>
                  </div>
                </div>
                <div style={{ 
                  fontSize: '12px', 
                  padding: '4px 8px', 
                  backgroundColor: getStatusColor(person.status),
                  color: 'white',
                  borderRadius: '12px',
                  fontWeight: 'bold'
                }}>
                  {person.status || 'Active'}
                </div>
              </div>
              
              {person.phone && (
                <div style={{ fontSize: '14px', color: '#666', marginBottom: '0.5rem' }}>
                  📞 {person.phone}
                </div>
              )}
              
              {selectedPerson?.id === person.id && (
                <div style={{ 
                  marginTop: '1rem', 
                  paddingTop: '1rem', 
                  borderTop: '1px solid #dee2e6',
                  fontSize: '14px'
                }}>
                  {person.address1 && (
                    <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                      🏠 {person.address1}
                      {person.city && `, ${person.city}`}
                      {person.state && `, ${person.state}`}
                      {person.zip && ` ${person.zip}`}
                    </div>
                  )}
                  {person.title && (
                    <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                      💼 {person.title}
                    </div>
                  )}
                  {person.about && (
                    <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                      ℹ️ {person.about}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MobilePeople;